import type { InjectionKey, Ref } from 'vue'
import { DataActions, ContentDataRouterConfig, DataDisplayController, ImageSizeRestriction } from '@/interfaces'
import { useTableRowSelection } from '@/composables/useTableRowSelection/useTableRowSelection'
import { useVideoDraftsEdit } from '@/composables/useVideoDraftsEdit/useVideoDraftsEdit'

export const PLAYLIST_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('playlist actions')
export const DOMAINS_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('domains actions')
export const WIDGET_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('widget actions')
export const EXCLUDED_DOMAINS_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('excluded actions')
export const OFFERED_PACKAGES_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('offered packages actions')
export const MY_IMPORTS_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('myimports actions')
export const CONTENT_ROUTER_INJECTION_KEY: InjectionKey<ContentDataRouterConfig> = Symbol('content router')
export const VIDEO_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('video router')
export const INVENTORY_PAIRED_URLS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('paired url actions')
export const MY_PACKAGES_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('my packages actions')
export const SETTINGS_USERS_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('setting users actions')
export const SETTINGS_API_KEYS_ACTIONS_INJECTION_KEY: InjectionKey<DataActions> = Symbol('setting api keys actions')
export const UPLOAD_VIDEO_NOTIFY_NEW_INJECTION_KEY: InjectionKey<Ref<string[]>> = Symbol('new videos notifications')
export const DATA_DISPLAY_INJECTION_KEY: InjectionKey<Ref<DataDisplayController | undefined>> = Symbol('datadisplay')
export const MODAL_ACTIONS_INJECTION_KEY: InjectionKey<() => Promise<void>> = Symbol('modal actions')
export const BULK_SELECT_INJECTION_KEY: InjectionKey<ReturnType<typeof useTableRowSelection>> = Symbol('bulk select')
export const VIDEO_DRAFT_EDIT_INJECTION_KEY: InjectionKey<ReturnType<typeof useVideoDraftsEdit>> = Symbol('draft edit')
export const UPLOAD_SOURCE_TAB_INJECTION_KEY: InjectionKey<Ref<string>> = Symbol('upload source tab')

export const KeyMap: { [key: string]: number } = {
  TAB: 9,
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  P: 80,
  C: 67,
  F: 70,
  M: 77,
  SEMI_COLON: 186,
  COMMA: 188,
  PERIOD: 190
}

export enum ImageTypes {
  personalProfile = 'personalProfile',
  organizationProfile = 'organizationProfile',
  channelProfile = 'channelProfile',
  channelBanner = 'channelBanner',
  horizontalThumbnail = 'horizontalThumbnail',
  verticalThumbnail = 'verticalThumbnail',
  coverPackage = 'coverPackage'
}

export const IMAGE_MIN_SIZES: ImageSizeRestriction = {
  personalProfile: {
    width: 120,
    height: 120
  },
  organizationProfile: {
    width: 120,
    height: 120
  },
  channelProfile: {
    width: 200,
    height: 200
  },
  channelBanner: {
    width: 1235,
    height: 338
  },
  horizontalThumbnail: {
    width: 640,
    height: 360
  },
  verticalThumbnail: {
    width: 360,
    height: 640
  },
  coverPackage: {
    width: 388,
    height: 109
  }
}

export const IMAGE_MAX_SIZES: Partial<ImageSizeRestriction> = {
  personalProfile: {
    width: 1200,
    height: 1200
  },
  organizationProfile: {
    width: 1200,
    height: 1200
  },
  channelProfile: {
    width: 1200,
    height: 1200
  },
  coverPackage: {
    width: 388,
    height: 109
  }
}

export const S3_UPLOAD_PROGRESS_THRESHOLD = 0.5

export const NEW_VIDEOS_IN_PROCESS_KEY = 'new-videos-in-process'
export const PROCESSING_PANEL_IS_COLLAPSED_KEY = 'processing-panel-is-collapsed'
export const VIDEO_DRAFTS_STORAGE_LIMIT = 50
